import {createImgDom } from "../helpers/gameCanvasHelper";
import TwoRowBetSvg from "../assets/images/game/2_row_bet.svg";
import ThreeRowBetSvg from "../assets/images/game/3_row_bet.svg";
import OneRowBetSvg from "../assets/images/game/1_row_bet.svg";
import TwoRowBetClickedSvg from "../assets/images/game/2_row_bet_clicked.svg";
import ThreeRowBetClickedSvg from "../assets/images/game/3_row_bet_clicked.svg";
import OneRowBetClickedSvg from "../assets/images/game/1_row_bet_clicked.svg";

const oneRowBetImg = createImgDom(OneRowBetSvg);
const twoRowBetImg = createImgDom(TwoRowBetSvg);
const threeRowBetImg = createImgDom(ThreeRowBetSvg);
const oneRowBetHighlightingImg = createImgDom(OneRowBetClickedSvg);
const twoRowBetHighlightingImg = createImgDom(TwoRowBetClickedSvg);
const threeRowBetHighlightingImg = createImgDom(ThreeRowBetClickedSvg);

export const betTypes = {
  under: 0,
  over: 1,
  range: 2,
}

export const betStatuses = {
  lose:0,
  win:1,
  pending: 2,
}

export const rowBetBlockImages = {
  default: {
    [1]: oneRowBetImg,
    [2]: twoRowBetImg,
    [3]: threeRowBetImg,
  },
  highlighting: {
    [1]: oneRowBetHighlightingImg,
    [2]: twoRowBetHighlightingImg,
    [3]: threeRowBetHighlightingImg,
  }
}